import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { AuthLayout } from "@/components/layout/AuthLayout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, apiError } from "@/lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true); setError("");
        try {
            await api.post("/auth/forgot-password", { email });
            setDone(true);
        } catch (err) {
            setError(apiError(err.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthLayout title="Reset password" subtitle="We'll send a reset link to your email.">
            {done ? (
                <div className="text-center py-6" data-testid="forgot-success">
                    <MailCheck className="w-10 h-10 text-success mx-auto mb-4" />
                    <p className="text-sm text-muted-foreground">
                        If an account exists for <span className="text-white font-mono">{email}</span>, a reset link has been sent.
                        <br /><span className="text-xs">(In this demo, the link is printed to the backend logs.)</span>
                    </p>
                    <Link to="/login" className="inline-block mt-6 text-volt hover:underline text-sm">Back to sign in</Link>
                </div>
            ) : (
                <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
                    <div className="space-y-2">
                        <Label className="text-xs uppercase tracking-wider text-muted-foreground">Email</Label>
                        <Input data-testid="forgot-email" type="email" required value={email}
                            onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com"
                            className="bg-surface border-border rounded-sm h-11" />
                    </div>
                    {error && <div className="text-sm text-alert font-mono">{error}</div>}
                    <button data-testid="forgot-submit" disabled={loading} type="submit"
                        className="w-full h-11 rounded-sm bg-volt text-black font-semibold hover:bg-[#33ceff] transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
                        {loading && <Loader2 className="w-4 h-4 animate-spin" />} Send reset link
                    </button>
                    <p className="text-sm text-muted-foreground text-center">
                        <Link to="/login" className="text-volt hover:underline">Back to sign in</Link>
                    </p>
                </form>
            )}
        </AuthLayout>
    );
}
